package ui.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun Footer(
    onNavigateToTerms: () -> Unit = {},
    onNavigateToPrivacy: () -> Unit = {}
) {
    Footer(attrs = {
        classes("bg-gray-900", "dark:bg-medical-surfaceDark", "text-white", "py-16", "px-4", "border-t", "dark:border-medical-surfaceVariantDark")
    }) {
        Div(attrs = {
            classes("max-w-7xl", "mx-auto", "flex", "flex-col", "md:flex-row", "justify-between", "items-center", "gap-8")
        }) {
            Div {
                H3(attrs = { classes("text-xl", "font-bold", "mb-2") }) { Text("Dr. Recipe") }
                P(attrs = { classes("text-gray-400", "text-sm") }) { 
                    Text("© 2026 ArtisanCode. Soluciones para simplificar tu día a día.") 
                }
                // Badge Tecnológico sutil
                P(attrs = { 
                    classes("text-gray-500", "text-[10px]", "mt-4", "uppercase", "tracking-[0.2em]", "font-medium") 
                }) { 
                    Text("Engineering by ArtisanCode | Kotlin Multiplatform Ecosystem") 
                }
            }

            // Bloque derecho: Redes Sociales + Enlaces Legales
            Div(attrs = {
                classes("flex", "flex-col", "items-center", "md:items-end", "gap-6", "md:pr-24")
            }) {
                // Redes Sociales
                Div(attrs = { classes("flex", "gap-6") }) {
                    // Instagram
                    A(href = "https://www.instagram.com/dr.recipeapp", attrs = {
                        classes("text-gray-400", "hover:text-pink-500", "transition-all", "hover:scale-110")
                        attr("title", "Instagram")
                        attr("target", "_blank")
                        attr("rel", "noopener noreferrer")
                    }) {
                        Img(
                            src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='2' y='2' width='20' height='20' rx='5' ry='5'%3E%3C/rect%3E%3Cpath d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z'%3E%3C/path%3E%3Cline x1='17.5' y1='6.5' x2='17.51' y2='6.5'%3E%3C/line%3E%3C/svg%3E",
                            attrs = { classes("w-5", "h-5") }
                        )
                    }
                    
                    // Facebook
                    A(href = "https://www.facebook.com/drrecipeapp/", attrs = {
                        classes("text-gray-400", "hover:text-blue-500", "transition-all", "hover:scale-110")
                        attr("title", "Facebook")
                        attr("target", "_blank")
                        attr("rel", "noopener noreferrer")
                    }) {
                        Img(
                            src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z'%3E%3C/path%3E%3C/svg%3E",
                            attrs = { classes("w-5", "h-5") }
                        )
                    }
                }

                // Enlaces Legales
                Div(attrs = { classes("flex", "gap-8", "text-sm") }) {
                    A(href = "javascript:void(0)", attrs = { 
                        classes("text-gray-400", "hover:text-white", "no-underline", "transition-colors") 
                        onClick { onNavigateToTerms() }
                    }) { Text("Términos") }
                    A(href = "javascript:void(0)", attrs = { 
                        classes("text-gray-400", "hover:text-white", "no-underline", "transition-colors") 
                        onClick { onNavigateToPrivacy() }
                    }) { Text("Privacidad") }
                }
            }
        }
    }
}
